/** @jsxImportSource react */

import { useShare } from '@common/helpers/share';
import { ValidChecklists } from '@react/tools/constants/data';
import { useRouter } from 'next/router';

import { ToolHero } from './Styles';
import TouringChecklistForm from './TouringChecklistForm';
import { ToolDetails } from '../types';

export default function TouringChecklistSelector({
  checkListName,
  heading,
  description,
  shortDescription,
}: {
  checkListName: ValidChecklists;
} & ToolDetails) {
  const { asPath } = useRouter();

  const { share } = useShare();

  return (
    <>
      <ToolHero
        heading={heading}
        subheading={description}
        onShare={() => {
          share({
            title: heading,
            text: shortDescription || description || '',
            url: `${window.location.origin}${asPath}`,
          });
        }}
      />
      <TouringChecklist checkListName={checkListName} heading={heading} />
    </>
  );
}

function TouringChecklist({
  checkListName,
  heading,
}: {
  checkListName: ValidChecklists;
  heading: string;
}) {
  switch (checkListName) {
    case 'assisted-living-touring-checklist':
      return <TouringChecklistForm type={checkListName} heading={heading} />;
    case 'memory-care-touring-checklist':
      return <TouringChecklistForm type={checkListName} heading={heading} />;
    case 'independent-living-touring-checklist':
      return <TouringChecklistForm type={checkListName} heading={heading} />;

    default:
      return null;
  }
}
